module.exports = __webpack_public_path__ + "img/d200908-1.a7ca910d.jpg";